import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token') || '';

  const [newPassword, setNewPassword]   = useState('');
  const [confirmPassword, setConfirm]   = useState('');
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState('');
  const [success, setSuccess]           = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmPassword) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/reset-password`, { token, newPassword });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to reset password. The link may be invalid or expired.');
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem',
      }}>
        <div style={{ width: '100%', maxWidth: 440 }}>
          <div style={{ background: '#fff', borderRadius: 18, padding: '2rem', boxShadow: '0 20px 60px rgba(0,0,0,.3)', textAlign: 'center' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>❌</div>
            <h5 className="fw-bold mb-2">Invalid Reset Link</h5>
            <p className="text-muted" style={{ fontSize: 14 }}>This link is missing the reset token. Please request a new reset link.</p>
            <Link to="/forgot-password" className="btn fw-semibold mt-2" style={{ background: 'linear-gradient(135deg, #6366f1, #8b5cf6)', color: '#fff', borderRadius: 10 }}>
              Request New Link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem',
    }}>
      <div style={{ width: '100%', maxWidth: 440 }}>
        {/* Logo */}
        <div className="text-center mb-4">
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: 52, height: 52, borderRadius: 13,
            background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
            fontSize: 26, fontWeight: 900, color: '#fff', marginBottom: 12,
            boxShadow: '0 8px 24px rgba(99,102,241,.4)',
          }}>Z</div>
          <h2 style={{ color: '#fff', fontWeight: 800, margin: 0 }}>Reset Password</h2>
          <p style={{ color: '#94a3b8', marginTop: 4, fontSize: 14 }}>
            Choose a new password for your account
          </p>
        </div>

        <div style={{ background: '#fff', borderRadius: 18, padding: '2rem', boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
          {success ? (
            <div className="text-center">
              <div style={{ fontSize: 48, marginBottom: 12 }}>🎉</div>
              <h5 className="fw-bold mb-2">Password Reset!</h5>
              <p className="text-muted" style={{ fontSize: 14 }}>
                Your password has been updated. Redirecting you to sign in…
              </p>
              <div className="spinner-border spinner-border-sm text-primary mt-2" />
            </div>
          ) : (
            <>
              {error && (
                <div className="alert alert-danger d-flex align-items-center gap-2 py-2" style={{ fontSize: 14 }}>
                  <span>⚠️</span> {error}
                  {error.toLowerCase().includes('expired') || error.toLowerCase().includes('invalid') ? (
                    <Link to="/forgot-password" className="ms-auto text-danger fw-semibold" style={{ fontSize: 13, whiteSpace: 'nowrap' }}>
                      Request new link →
                    </Link>
                  ) : null}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label fw-semibold">New Password</label>
                  <input
                    type="password"
                    className="form-control form-control-lg"
                    placeholder="Min. 6 characters"
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                    required
                    autoFocus
                    minLength={6}
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label fw-semibold">Confirm New Password</label>
                  <input
                    type="password"
                    className="form-control form-control-lg"
                    placeholder="Repeat password"
                    value={confirmPassword}
                    onChange={e => setConfirm(e.target.value)}
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn w-100 fw-semibold"
                  disabled={loading}
                  style={{
                    background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
                    color: '#fff', padding: '12px', fontSize: 15, borderRadius: 10,
                  }}
                >
                  {loading
                    ? <><span className="spinner-border spinner-border-sm me-2" />Saving…</>
                    : '🔐 Reset Password'}
                </button>
              </form>
            </>
          )}

          <div className="text-center mt-3">
            <Link to="/login" style={{ color: '#6366f1', fontSize: 14, textDecoration: 'none' }}>
              ← Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
